import React, { useEffect, useState } from 'react';
import { Radio } from 'antd';
import { useTranslation } from 'react-i18next';

import { LabeledInput } from '../Input/LabeledInput';
import { DrugGenericNameDropdown } from './DrugGenericNameDropdown';

import styles from './GenericNameDdlOrText.module.scss';

export const isManualGenericNameFormValue = v =>
  v && typeof v === 'object' && v.value != null && String(v.value).startsWith('manual:');

const isManualValue = isManualGenericNameFormValue;

const toManualObject = text => {
  const t = String(text ?? '').trim();

  return t === '' ? undefined : { text: t, value: `manual:${t}` };
};

const emptyManualPlaceholder = () => ({ text: '', value: 'manual:' });

export const GenericNameDdlOrText = ({
  label,
  id,
  onChange,
  withAsterisks,
  disabled,
  value
}) => {
  const [ t ] = useTranslation();
  const [ mode, setMode ] = useState(() => (isManualValue(value) ? 'text' : 'ddl'));

  useEffect(() => {
    if (value == null || value === '') {
      setMode('ddl');

      return;
    }
    setMode(isManualValue(value) ? 'text' : 'ddl');
  }, [ value ]);

  const onModeChange = e => {
    const next = e.target.value;
    if (next === 'ddl') {
      setMode('ddl');
      if (isManualValue(value)) {
        onChange(undefined);
      }

      return;
    }
    setMode('text');
    onChange(
      isManualValue(value)
        ? (toManualObject(value?.text ?? '') ?? emptyManualPlaceholder())
        : emptyManualPlaceholder()
    );
  };

  return (
    <div className={ styles.wrap }>
      <Radio.Group
        className={ styles.toggle }
        buttonStyle="solid"
        value={ mode }
        onChange={ onModeChange }
        disabled={ disabled }
      >
        <Radio.Button value="ddl">{t('fields.genericNameSource.list')}</Radio.Button>
        <Radio.Button value="text">{t('fields.genericNameSource.manual')}</Radio.Button>
      </Radio.Group>
      {mode === 'ddl' && (
        <DrugGenericNameDropdown
          label={ label }
          id={ id }
          onChange={ onChange }
          withAsterisks={ withAsterisks }
          disabled={ disabled }
          value={ isManualValue(value) ? undefined : value }
        />
      )}
      {mode === 'text' && (
        <LabeledInput
          label={ label }
          id={ id }
          withAsterisks={ withAsterisks }
          disabled={ disabled }
          value={ value?.text ?? '' }
          maxLength={ 400 }
          onChange={ e => {
            onChange(toManualObject(e.target.value) ?? emptyManualPlaceholder());
          } }
        />
      )}
    </div>
  );
};
